import { LocationDetails } from '@griply/types';

import { FirebaseHttpsCallableFactory } from '../types/firebase-functions';

export type GetLocationDetailsPayload = {
  placeId: string;
  // the exact token the autocomplete requests carried — closes the billed session
  sessionToken: string;
  languageCode?: string;
};

export type GetLocationDetailsOptions<TFunctions> = {
  functions: TFunctions;
  httpsCallable: FirebaseHttpsCallableFactory<TFunctions>;
  payload: GetLocationDetailsPayload;
};

export const getLocationDetails = async <TFunctions>(
  options: GetLocationDetailsOptions<TFunctions>,
): Promise<LocationDetails> => {
  const { functions, httpsCallable, payload } = options;
  const callable = httpsCallable<GetLocationDetailsPayload, LocationDetails>(
    functions,
    'locations-placeDetails',
  );

  const { data } = await callable(payload);

  return data;
};
